let ctx = null;
let timer = null;

const beep = (freq, start, dur) => {
  const o = ctx.createOscillator();
  const g = ctx.createGain();
  o.type = "square";
  o.frequency.value = freq;
  g.gain.setValueAtTime(0.35, ctx.currentTime + start);
  g.gain.setValueAtTime(0, ctx.currentTime + start + dur);
  o.connect(g).connect(ctx.destination);
  o.start(ctx.currentTime + start);
  o.stop(ctx.currentTime + start + dur + 0.02);
};

const pattern = () => {
  [0, 0.3, 0.6, 0.9].forEach((t, i) => beep(i % 2 ? 660 : 880, t, 0.22));
  if (navigator.vibrate) navigator.vibrate([300, 150, 300, 150, 300]);
};

export function startRing() {
  try {
    ctx = ctx || new (window.AudioContext || window.webkitAudioContext)();
    if (ctx.state === "suspended") ctx.resume();
    if (timer) return;
    pattern();
    timer = setInterval(pattern, 1800);
  } catch (e) { /* audio not available */ }
}

export function stopRing() {
  if (timer) { clearInterval(timer); timer = null; }
  if (navigator.vibrate) navigator.vibrate(0);
}

export function beepOnce() {
  try {
    ctx = ctx || new (window.AudioContext || window.webkitAudioContext)();
    if (ctx.state === "suspended") ctx.resume();
    pattern();
  } catch (e) { /* audio not available */ }
}
